import AboutContent from "./pages/aboutContent/AboutContent";
import UserSupport from "./pages/userSupport/UserSupport";
import React from 'react';
import './App.css';
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/login/Login"
import ForgotPassword from './components/forgotPassword/ForgotPassword';
import OtpVerification from './components/otpVerification/OtpVerification';
import ResetPassword from './components/resetPassword/ResetPassword';
import ManageChat from './pages/ManageChat/ManageChat';
import ManageCategories from './pages/manageCategories/ManageCategories';
import ManageProduct from './pages/manageProducts/ManageProduct';
import SaleFeeManagement from './pages/saleFeeManagement/SaleFeeManagement';
import OrderManagement from './pages/orderManagement/OrderManagement';
import Faq from './pages/fag/Faq';
import AddFaq from './pages/fag/addFaq/AddFaq';
import TermAndCondition from './pages/termAndCondition/TermAndCondition';
import PrivacyAndPolicy from './pages/privacyAndPolicy/PrivacyAndPolicy';

import CommunicationsGuidelines from './pages/communicationsGuidelines/CommunicationsGuidelines';
import EligibilityShopping from './pages/eligibilityShopping/EligibilityShopping';
import StorePolicy from './pages/storePolicy/StorePolicy';

import Private from './components/Private';
import PageNotFound from './pageNotFound/PageNotFound';
import SocialLinks from './pages/SocialLinks/SocialLinks';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-quill/dist/quill.snow.css';

import OrderSettings from "./pages/orderSettings/OrderSettings";

function App() {

  return (
    <Routes>
      <Route path="/" element={<Navigate to={'/login'} />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/otp-verify" element={<OtpVerification />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/" element={<Private />} >
        <Route path="manage-categories" element={<ManageCategories />} />
        <Route path="manage-products" element={<ManageProduct />} />
        <Route path="order-settings" element={<OrderSettings />} />
        <Route path="social-links" element={<SocialLinks />} />
        <></>
        <Route path="faqs" element={<Faq />} />
        <Route path="add-faq" element={<AddFaq />} />
        <Route path="term-and-condition" element={<TermAndCondition />} />
        <Route path="privacy-and-policy" element={<PrivacyAndPolicy />} />
        
        
        <Route path="communications-guidelines" element={<CommunicationsGuidelines />} />
        <Route path="eligibility-shopping" element={<EligibilityShopping />} />
        <Route path="store-policy" element={<StorePolicy />} />
        <Route path="*" element={<PageNotFound />} />
      </Route>
    
<Route path="static-content" element={<AboutContent />} />
</Routes>

  )
}



export default App;
